import { ClientService } from "../../shared/services/client.service";
import { ManagedClient } from "../../shared/models/managed-client";
import { PaginatedResultsLoader } from "../../shared/models/paginated-results-loader";
import { PaginatedResultsLoaderFactory } from "../../shared/services/pagination-results-loader-factory.service";
import { User } from "../../shared/models/user";
import { Injectable } from "@angular/core";
import { AuthService } from "../../login/services/auth.service";
import { ISubscription } from "rxjs/Subscription";

@Injectable()
export class ClientSearchService {

    private _searchValue:{firstName?:string, lastName?:string, id?:string};
    private _resultsLoader:PaginatedResultsLoader<ManagedClient>;
    private _clients:ManagedClient[];
    private _searchUser:User;
    private _showAllUsers:boolean;
    private _exactMatch:boolean;
    private _userSubscription:ISubscription;
    private _clientSubscription:ISubscription;

    constructor(private _clientService:ClientService, private _paginationFactory:PaginatedResultsLoaderFactory
        , private authService:AuthService) {
        this._showAllUsers = false;
        this._clients = [];
        // when we get a new client let's make sure the client always displays when a user is added.
        this._clientSubscription = this._clientService.getClientObservable().subscribe(c => {
            if (!c) { // TODO: stephen we are using behaviorsubject which returns the first value on init... not sure I like this and we should
                // try doing this differently.
                return; // skip any invalid input
            }

            if (this.hasClientInResults(c)) {
                this.updateClient(c);
            }
            else {
                this.handleNewClient(c);
            }
        });

        this._userSubscription = this.authService.getLoginState().subscribe(state => {
            if (!state.isLoggedIn) {
                this.clearSearch();
            }
        });

        this.restoreSearchSettings();
        
    }

    private restoreSearchSettings() {
        if (localStorage) {
            let clientSearchData = localStorage.getItem('ClientSearchService');
            if (clientSearchData !== null) {
                try {
                    let data = JSON.parse(clientSearchData);
                    if (data.hasOwnProperty('_showAllUsers')) {
                        this._showAllUsers = data._showAllUsers === true;
                    }

                    if (data.hasOwnProperty('_exactMatch')) {
                        this._exactMatch = data._exactMatch === true;
                    }
                }
                catch (error) {
                    console.error("Failed to extract ClientSearchService data", error);
                }
            }
        }
    }

    private saveSearchSettings() {
        if (localStorage) {
            let clientSearchData = {
                _showAllUsers: this._showAllUsers
                ,_exactMatch: this._exactMatch
            };
            try {
                localStorage.setItem("ClientSearchService", JSON.stringify(clientSearchData));
            } catch (error) {
                console.error("Failed to save ClientSearchService data", error);
            }
        }
    }

    ngOnDestroy() {
        this._userSubscription.unsubscribe();
        this._clientSubscription.unsubscribe();
    }

    get SearchValue() {
        return this._searchValue;
    }

    set SearchValue(v:{firstName?:string, lastName?:string, clientID?:string}) {
        this._searchValue = v;
    }

    get ShowAllUsers() : boolean {
        return this._showAllUsers;
    }

    set ShowAllUsers(v:boolean) {
        this._showAllUsers = v;
        this.saveSearchSettings();
    }

    get ExactMatch() : boolean {
        return this._exactMatch;
    }

    set ExactMatch(v:boolean) {
        this._exactMatch = v;
        this.saveSearchSettings();
    }

    public clearSearch() {
        this._resultsLoader = null;
        this._searchUser = null;
        this._searchValue = {};
        this._clients = [];
    }

    private hasClientInResults(c:ManagedClient) {
        let id = c.id || null;
        return this._clients.find(c => c.id == id) != null;
    }
    private updateClient(c:ManagedClient) {
        let id = c.id || null;
        let index = this._clients.findIndex(c => c.id == id);
        if (this._searchUser && c.user.id != this._searchUser.id) {
            this._clients.splice(index, 1);
        }
        else {
            this._clients[index] = c;
        }
    }

    private handleNewClient(c:ManagedClient) {
        if (this._searchValue != null) {
            this.search(this._searchValue, this._searchUser);
        }
        else {
            this._clients.unshift(c);
        }
    }

    public search(search:{firstName?:string, lastName?:string, id?:string}, user:User) : Promise<ManagedClient[]> {
        this.clearSearch();

        this._searchUser = user;
        this._searchValue = search;
        let queryFunction = this._clientService.searchClientList.bind(this._clientService, search, user);
        this._resultsLoader = this._paginationFactory.getResultsLoader<ManagedClient>(queryFunction);
        return this._resultsLoader.getResults()
            .then((results:ManagedClient[]) => {
                this._clients = results;
                return results;
        });
    }

    public hasMoreResults() : boolean {
        return this._resultsLoader.hasMoreResults();
    }
    
    public loadMore() : Promise<ManagedClient[]> {
        // load more results
        return this._resultsLoader.loadMore()
        .then((results:ManagedClient[]) => {
            console.log(results);
            this._clients = results;
            return results;
        });
    }
    public getClientList(user:User) : Promise<ManagedClient[]> {
        this._searchUser = user;
        if (!this._resultsLoader) {
            let queryFunction = this._clientService.getClientList.bind(this._clientService, user);
            this._resultsLoader = this._paginationFactory.getResultsLoader<ManagedClient>(queryFunction);
            return this._resultsLoader.getResults().then((clients) => {
                this._clients = clients;
                return clients;
            });
        }
        else {
            return Promise.resolve(this._clients);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/services/client-search.service.ts